// Path: src\Components\RouterFiles\routes.js
export const routesFrontend = {
    "createProfile": "/",
    "undermaintaintance": "/under-maintenance",
    "howtojoin": "/how-to-join",
    "home": "/home",
    "gameType": "/game-type/:id",
    "htmlFreeGames": "/htmlFreeGames",
    // "htmlFreeGameType": "/htmlFreeGames/game-type",
    "htmlFreeGameDirectLink": "/htmlFreeGames/direct-link",
    "htmlFreeGameType": "/htmlFreeGames/game-type/:id",
    "htmlFreeGame": "/htmlFreeGames/game/:id",
    "tournamentlist": "/tournament/list",
    "tournamentregistration": "/team-registration",
    'worldOfEports': '/world-of-eports',
    'worldOfEportsPopularVideos': '/world-of-eports/popularvideos',
    'worldOfEportsPopularVideo': '/world-of-eports/popularvideo',
    'worldOfEportsNews': '/world-of-eports/esports-news',
     "esportdetail" : "/world-of-eports/detail/:id",
    'worldOfEportsUserprofile': '/world-of-eports/user-profile',
    "profile": '/profile',
    "editprofile": '/edit/profile',
    "rewards": "/rewards",
    "more": "/more",
    "tournamentdetails": "/tournament/details/:id",
    "contestlist": "/contest/list",
    "contestdetails": "/contest/details/:id",
    "mycontest": "/my-contest/list/:id",
    "termsofuse": "/more/terms-of-use",
    "privacypolicy": "/more/privacy-policy",
    "leaderboard": "/more/leaderboard",
    "vipoints": "/more/vipoints",
    "myRecentTransaction": "/rewards/my-recent-transactions",
    "customerCare": '/more/customer-care',
    "raiseAComplaint": "raise-a-complaint",
    "ticketDetails": "ticket/details/:id",
    "privateScrim": "private-contest",
    "privateScrimList": "private-contest/list",
    "privateScrimSummary": "private-scrim-summary",
    "createScrim": "create-contest",
    "manageScrim": "manage-contest/:id",
    "editScrim": "edit-scrim/:id",
    "manageScrimDetail": "private-contest/detail/:id",
    "subscription": "/more/subscription-pack",
    "paymentPayuStatus": "/payment-payu-status",
     "howtoCreateScrim" : "how-to-create-scrim",
     "userProfile":"/user-profile/:id"
}